<template>
  <div class="panel panel-default">
    <div class="panel-heading" :title="questao.enunciado">{{
      caixaAlta(limitar(questao.enunciado, 38))
    }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Tipo</strong></td>
            <td>{{ questao.tipo }}</td>
          </tr>
          <tr>
            <td><strong>Resposta obrigatória</strong></td>
            <td>{{ questao.obrigatorio ? 'Sim' : 'Não' }}</td>
          </tr>
          <tr>
            <td><strong>Resposta padrão</strong></td>
            <td v-if="!questao.respostaPadrao">-</td>
            <td v-else>
              <span
                v-if="
                  ['Domínio', 'Inteiro', 'Fracionário'].includes(questao.tipo)
                "
              >
                {{ questao.respostaPadrao }}
              </span>
              <span v-else-if="questao.tipo === 'Data'">
                {{ formatarData(questao.respostaPadrao, 'DD/MM/YYYY') }}
              </span>
              <span v-else-if="questao.tipo === 'Sim/Não'">
                {{ questao.respostaPadrao ? 'Sim' : 'Não' }}
              </span>
              <span v-else-if="questao.tipo === 'Texto'">
                {{ limitar(questao.respostaPadrao, 35) }}
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="questao.ativo ? 'text-success' : 'text-danger'">{{
              questao.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/evolucao/questao/cadastro/' + questao._id"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-edit" /> Editar</RouterLink
        >
      </div>
    </div>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'QuestaoFicha',
  props: {
    questao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
